/* eslint-disable */
import React from "react"
import MultiSelect from "../atoms/MultiSelect.atom"
import ClientChip from "../molecules/ClientChip.molecule"
import ProjectChip from "../molecules/ProjectChip.molecule"
import InlineMultiSelectDropdown from "../molecules/InlineMultiSelectDropdown.molecule"

const MultiSelectClientProjectFilter = ({ data, options }) => {
  const projects = data.map((client) => ({
    clientId: client?.data?.clientId,
    name: client.data.name,
    code: client.data.code,
    items: client.children.map((child) => ({
      clientId: client?.data?.clientId,
      name: child.data.name,
      code: child.data?.tagName || child.data.name.split("-")[0].trim(),
      clientCode: client?.data?.code,
    })),
  }))
  const getSelectedItemsLabel = () => {
    const selectedValues = options.value || []
    const selectedParents = selectedValues.filter((value) =>
      projects.some((project) => project.name === value)
    )
    const adjustedSelectedCount = selectedValues.length - selectedParents.length
    return adjustedSelectedCount > 0 ?
        `${adjustedSelectedCount} seleccionados`
      : "Ningún proyecto seleccionado"
  }
  return (
    <InlineMultiSelectDropdown
      className="client-project-filter-multiselect max-w-23rem"
      value={options.value || []}
      options={projects}
      onChange={(value) => {
        let finalSelection = []

        projects.map((project) => {
          project.items.map((item) => {
            if (value.includes(item.name)) {
              finalSelection.push(item.name)
              if (!finalSelection.includes(project.name)) {
                finalSelection.push(project.name)
              }
            }
          })
        })
        options.filterCallback(finalSelection)
      }}
      optionLabel="name"
      optionValue="name"
      placeholder={!projects || !projects?.length ? "Sin opciones" : "Todos"}
      optionGroupLabel="name"
      optionGroupChildren="items"
      optionGroupTemplate={(option) => {
        return <ClientChip clientCode={option.code} className="w-fit" />
      }}
      itemTemplate={(option) => {
        return (
          <div className="flex gap-2">
            <ProjectChip
              clientCode={option.clientCode}
              projectCode={option.code}
            />
            <span className="overflow-hidden white-space-nowrap text-overflow-ellipsis">
              {option.name?.split("-")[1]}
            </span>
          </div>
        )
      }}
      selectedItemTemplate={(option) => {
        return (
          <ProjectChip
            key={option.name + option.code + option.clientCode}
            clientCode={option.clientCode}
            projectCode={option.code}
          />
        )
      }}
      hideToggleButton
      initiallyExpanded
      maxSelectedLabels={6}
      selectedItemsLabel={getSelectedItemsLabel()}
      disabled={!projects || !projects?.length}
    />
  )
}

export default MultiSelectClientProjectFilter
